<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <b-card class="mx-auto col-lg-10 col-md-12 col-sm-12 border-0">
      <b-card-title class="mb-4 pb-4">
        <div class="row">
          <span class="survey-type-badge btn-primary mr-2">
            <fa-icon name="file-medical-alt" size="6x" />
          </span>
          <span>
            {{ surveytype_name }} Report for {{ survey && survey.survey_name }}
          </span>
        </div>
      </b-card-title>
      <!-- we have paid and all that stuff, and have loaded the report -->
      <div v-show="report_loaded == 1" class="mx-auto col-12">
        <b-row class="mb-4">
          <b-button
            class="mx-auto large col-4"
            variant="primary"
            @click.prevent="report_download"
          >
            Download report
          </b-button>
        </b-row>
        <!-- <b-row v-if="survey && survey.survey_type_id == 1">
          <b-button
            class="mx-auto mb-4 large col-4"
            variant="secondary"
            @click.prevent="rawdata_download"
          >
            OLD Download raw data
          </b-button>
        </b-row> -->
        <b-row v-if="survey && survey.survey_type_id == 1">
          <b-button
            class="mx-auto mb-4 large col-4"
            variant="secondary"
            @click.prevent="rawdata_excel_download"
          >
            Download raw data Excel
          </b-button>
        </b-row>
        <b-row
          v-if="survey && survey.survey_type_id == 1 && show_limited == true"
        >
          <b-button
            class="mx-auto mb-4 large col-4"
            variant="danger"
            @click.prevent="rawdata_excel_download_limited"
          >
            Download raw data Excel Limited
          </b-button>
        </b-row>
        <b-row>
          <b-button
            class="mx-auto large col-4"
            variant="warning"
            @click.prevent="receipt_download"
          >
            Download payment receipt
          </b-button>
        </b-row>
        <b-row>
          <b-button
            class="mx-auto large col-4 mt-4"
            variant="default"
            @click.prevent="back_to_survey"
          >
            Back to survey page
          </b-button>
        </b-row>
      </div>
      <!-- We have just paid and are waiting for the report to be generated -->
      <div
        v-show="report_paid == 1 && report_loaded == 0"
        class="align-center text-center mx-auto col-12"
      >
        <h2 class="align-center">Generating report...</h2>
      </div>
      <!-- We had already paid before and are waiting for the report to be generated -->
      <div v-show="invoice_status == 2 && report_loaded == 0">
        <h2 class="align-center">
          <b-spinner class="align-middle mr-2 text-primary" />
          Preparing report...
        </h2>
      </div>
      <!-- We have not paid -->
      <div
        v-if="invoice_status == 0 && report_loaded == 0 && report_paid == 0"
        class="mx-auto col-9"
      >
        <h4>Report Invoice</h4>
        <b-table
          id="invoiceheadtable"
          :items="invoicehead"
          :fields="invoiceheadfields"
          thead-class="hidden_header"
        />
        <b-table
          id="invoicedetailstable"
          :items="invoicedetails"
          :fields="invoicedetailsfields"
          foot-clone
        >
          <template v-slot:foot(item_text)>
            TOTAL SUM<br />
            <strong>VAT</strong><br />
            <strong>TOTAL SUM INCLUDING VAT</strong>
          </template>
          <template v-slot:foot(price)>
            {{ invoice.invoice_amount }} SEK<br />
            <strong>{{ invoice.invoice_vat_amount }} SEK</strong><br />
            <strong>{{ invoice.invoice_amount_inc_vat }} SEK</strong>
          </template>
        </b-table>

        <div class="justify-content-center text-center d-flex pb-2">
          <strong>Contact information:&nbsp;&nbsp;</strong>GDQ Associates AB,
          e-mail:&nbsp;&nbsp;<a href="mailto: gdq@gdq.se">gdq@gdq.se</a>,
          telephone: +46 76 052 52 03
        </div>
        <div class="justify-content-center text-center d-flex pb-2">
          <a :href="config.links.privacyPolicy"
            >Click here to view our privacy policy</a
          >
        </div>

        <b-form-group class="bg-warning px-4 pt-4">
          <b-form-checkbox
            v-model="invoice_accept"
            class="pb-4"
            @input="invoice_updateinfo"
          >
            <strong>
              I accept the
              <a href="https://gdq.se/en/terms-of-purchase/" target="_new">
                terms of purchase
              </a>
              and the charges as specified above
            </strong>
          </b-form-checkbox>
        </b-form-group>

        <b-form-group v-if="invoice_accept" label="I want to pay by;">
          <b-row class="justify-content-center">
            <b-button
              v-if="canpayInvoice()"
              variant="primary"
              class="mx-2"
              @click="payment = '2'"
            >
              Invoice
            </b-button>
            <b-button
              v-if="coupons > 0"
              variant="primary"
              class="mx-2"
              @click="payment = '3'"
            >
              Coupon
            </b-button>
            <b-button variant="primary" class="mx-2" @click="payment = '4'">
              Credit Card
            </b-button>
          </b-row>
        </b-form-group>
        <div v-if="payment == 2 || payment == 4">
          <h4>
            {{
              payment == 2
                ? "Invoice payment"
                : "Card payment - billing details"
            }}
          </h4>
          <b-form-group
            v-if="payment == 2"
            label="I want to receive my invoice by:"
          >
            <b-form-select
              v-model="e_invoice"
              :options="einvoiceoptions"
              @change="invoice_updateinfo"
            />
          </b-form-group>
          <span v-if="payment == 2">
            The invoice will be sent to the address you provide below. If you
            already have a link to e-invoices via your organisation, the invoice
            will be sent via that route. As a part of our environmental
            management, we encourage digital invoices. Enter your e-mail if you
            want to receive the invoice by e-mail.
          </span>
          <h5 class="mt-4">Payee information</h5>
          <b-form-group label-cols="4">
            <template v-slot:label>
              Invoice Reference
              <b>
                <span v-if="invoice_reference == ''" class="text-danger">
                  required
                </span>
              </b>
            </template>
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_reference"
              placeholder="Invoice reference"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4">
            <template v-slot:label>
              Name
              <b>
                <span v-if="invoice_name == ''" class="text-danger">
                  required
                </span>
              </b>
            </template>
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_name"
              placeholder="Name"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4" label="E-mail">
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_email"
              placeholder="Invoice e-mail"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4">
            <template v-slot:label>
              Company
              <b>
                <span v-if="invoice_company == ''" class="text-danger">
                  required
                </span>
              </b>
            </template>
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_company"
              placeholder="Company name"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4" label="Address">
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_address_1"
              placeholder="Address line 1"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4" label="">
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_address_2"
              placeholder="Address line 2"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4" label="Zip code">
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_zip_code"
              size="6"
              maxlength="6"
              class="col-3"
              placeholder="Zip code"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4" label="City">
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_city"
              placeholder="City"
              @keyup="invoice_updateinfo"
            />
          </b-form-group>
          <b-form-group label-cols="4">
            <template v-slot:label>
              VAT number/social security number
              <b>
                <span v-if="invoice_company_regno == ''" class="text-danger">
                  required
                </span>
              </b>
            </template>
            <b-form-input
              :class="`${anon ? 'g-anon' : ''}`"
              v-model="invoice_company_regno"
              placeholder="VAT number/social security number"
              @keyup="invoice_updateinfo"
            />
            <div>
              Fill out the VAT number (organisationsnummer) if the invoice
              should be issued to an organisation. If you wish to receive the
              invoice as a private individual, fill out your social security
              number (personnummer).
            </div>
          </b-form-group>
        </div>
        <b-form-group
          v-if="payment == 2"
          class="text-right align-right mt-4 pt-4"
        >
          <b-button
            :disabled="formok == false"
            size="lg"
            variant="primary"
            @click.prevent="invoice_save"
          >
            <span class="icon-file-presentation mr-2 pl-2" />Continue to the
            Report
          </b-button>
        </b-form-group>

        <!-- Coupon payment -->
        <div v-if="payment == 3">
          <b-form-group label="Please enter your coupon code">
            <b-input-group>
              <b-form-input v-model="coupon_code" :state="couponok != false" />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="coupon_code == ''"
                  class="btn-small pb-1 pt-1 btn-coupon"
                  @click.prevent="checkcoupon()"
                >
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 512 512"
                      focusable="false"
                      class="white fa-icon"
                    >
                      <path
                        d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                      />
                    </svg>
                  </span>
                  Use the coupon
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-alert :show="couponok == false" variant="danger">
              Invalid coupon
            </b-alert>
          </b-form-group>
        </div>
        <!-- Invoice payment -->

        <!-- DIBS payment -->
        <div v-if="payment == 1">
          <h5>Card Payment</h5>
          <div class="py-4 col-12 text-center align-center">
            Payment service provided by DIBS<br />
            <img
              class="ml-4"
              src="https://cdn.dibspayment.com/logo/checkout/combo/horiz/DIBS_checkout_kombo_horizontal_04.png"
              alt="DIBS - Payments made easy"
              width="270"
            />
          </div>
          <form
            id="gdq_dibsform"
            ref="gdq_dibsform"
            class="text-center align-center"
            method="post"
            action="https://payment.architrade.com/paymentweb/start.action"
          >
            <input
              type="hidden"
              name="amount"
              :value="invoice.dibs_amount * 100"
            />
            <input type="hidden" name="currency" value="SEK" />
            <input type="hidden" name="lang" value="en" />
            <input type="hidden" name="capturenow" value="yes" />
            <input type="hidden" name="decorator" value="responsive" />
            <input type="hidden" name="merchant" value="90219297" />
            <input type="hidden" name="orderid" :value="order_id" />
            <input
              type="hidden"
              name="ordertext"
              :value="invoice.invoice_text"
            />
            <input type="hidden" name="accepturl" :value="accept_url" />
            <input type="hidden" name="callbackurl" :value="callback_url" />
            <input type="hidden" name="cancelurl" :value="cancel_url" />
            <input type="hidden" name="gdqurl" :value="gdq_url" />
            <input
              v-if="consultant_id == 1"
              type="hidden"
              name="test"
              value="test"
            />
            <b-button
              size="lg"
              variant="primary"
              :disabled="invoice_accept == false"
              @click.prevent.stop="dibs_payment"
            >
              <span class="icon-receipt mr-2 pl-2" />Continue to DIBS Payment
            </b-button>
          </form>
        </div>
        <!-- NETS Easy Payment -->
        <div v-if="payment == 4 && invoice_accept">
          <b-button
            size="lg"
            variant="primary"
            class="mx-auto d-block mb-3"
            @click.prevent="startNetsPayment"
          >
            <span class="icon-receipt mr-2 pl-2" />Continue to Nets Payment
          </b-button>
          <!-- Hidden Nets component; we trigger its flow programmatically -->
          <div style="display: none">
            <NetsPayment
              ref="netsPayment"
              product-name="GDQ Report"
              :dibs-amount="invoice.dibs_amount"
              :order-id="order_id"
              :accept-url="web_url"
              :cancel-url="web_url"
            />
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import Navbar from './Navbar'
import Breadcrumb from './Breadcrumb'
import NetsPayment from './NetsPayment'
import { config } from '../../config'

export default {
  name: 'GroupSurveyReport',
  components: {
    Navbar,
    Breadcrumb,
    NetsPayment
  },
  data () {
    return {
      config,
      addressdone: false,
      consultant_id: this.$store.state.user_id,
      survey_id: 0,
      survey: null,
      surveytype_name: 'GDQ',
      survey_stage_id: 0,
      surveystages: [],
      invoice_status: 2,
      order_id: '0',
      invoice_id: '0',
      invoice: null,
      invoicehead: [],
      invoiceheadfields: [
        { key: 'label', label: '' },
        { key: 'value', label: '', tdClass: 'align-right text-right' }
      ],
      invoicedetails: [],
      invoicedetailsfields: [
        { key: 'item_text', label: 'Survey Member', sortable: false },
        {
          key: 'price',
          label: 'Price',
          sortable: false,
          thClass: 'align-right text-right',
          tdClass: 'align-right text-right'
        }
      ],
      invoice_reference: '',
      invoice_name: '',
      invoice_email: '',
      invoice_company: '',
      invoice_address_1: '',
      invoice_address_2: '',
      invoice_zip_code: '',
      invoice_city: '',
      invoice_company_regno: '',
      e_invoice: 1,
      einvoiceoptions: [
        // { 'value': '0', text: 'Paper invoice sent by post' },
        { value: '1', text: 'PDF invoice sent by e-mail' },
        { value: '2', text: 'E-invoice' }
      ],
      coupon_id: 0,
      coupon_code: '',
      couponok: null,
      invoice_accept: false,
      formok: false,
      payment: null,
      base_url: config.base_url,
      report_id: 0,
      report_paid: 0,
      report_loaded: 0,
      web_url: window.location + '',
      coupons: 0,
      spotify: '0',
      netspayment_id: this.$route.query.paymentid
        ? this.$route.query.paymentid
        : '',
      nets_paid_amount: 0,
      nets_invoice_amount: 0,
      show_limited:
        this.$store.state.user_usergroups.filter((ug) => {
          return ug.usergroup_id == 2 || ug.usergroup_id == 8
        }).length > 0
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    gdq_url: function () {
      var url = window.location
      return url
    }
  },
  async created () {
    console.log('user groups', this.$store.state.user_usergroups)
    console.log(
      'show_lilmited',
      this.$store.state.user_usergroups.filter((ug) => {
        return ug.usergroup_id == 2 || ug.usergroup_id == 8
      }).length > 0
    )
    await this.checknetspayment().then(() => {
      this.coupons_get()
      this.groupsurvey_get()
      this.invoice_get()
    })
  },
  methods: {
    canpayInvoice () {
      let ok = true
      if ([875, 3068, 996, 1074, 1863].includes(this.consultant_id)) {
        ok = false
      }
      if (this.$store.state.user.email.includes('vectorgroup')) {
        ok = false
      }
      return ok
    },
    async checknetspayment () {
      if (this.netspayment_id != '') {
        // Update the invoice and payment
        await this.$store
          .dispatch('netspayment_update', { paymentId: this.netspayment_id })
          .then((resp) => {
            if (resp.data.status == 'OK') {
              // Remove paymentID
              this.$router.push(this.$route.path)
            } else {
              alert(resp.data.error)
            }
          })
      }
    },
    back_to_survey () {
      this.$router.push('/group/survey')
    },
    coupons_get () {
      var filter = {
        consultant_id: {
          operator: '==',
          value: this.$store.state.user_id
        },
        coupon_invoice_id: {
          operator: '=',
          value: 0
        }
      }
      this.$store
        .dispatch('records_readall', {
          table_name: 'g_consultant_coupons',
          filter: filter
        })
        .then((result) => {
          this.coupons = result.data.result.length
        })
    },
    dibs_payment () {
      var payload = { invoice_id: this.invoice_id, payment_method_id: 1 }
      this.$store.dispatch('paymentlog_create', payload).then((resp) => {
        // ---------------------
        // Here we POST to DIBS
        // ---------------------
        this.$refs.gdq_dibsform.submit()
      })
    },
    report_download () {
      var reporturl = config.report_url + '/gdq_report.php?r=' + this.report_id
      var downloadURL = new URL(reporturl)
      var downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute(
        'download',
        'GDQ_Report_' +
          this.survey_id +
          '_' +
          new Date().toISOString().split('T')[0]
      )
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    rawdata_download () {
      this.$store
        .dispatch('gdqreport_rawdata_get', { survey_id: this.survey_id })
        .then((resp) => {
          var byteCharacters = atob(resp.data)
          var byteNumbers = new Array(byteCharacters.length)
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          var byteArray = new Uint8Array(byteNumbers)
          var blob = new Blob([byteArray], { type: 'application/pdf' })
          var fileURL = window.URL.createObjectURL(blob)
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            'GDQ_RawData_' +
              this.survey_id +
              '_' +
              new Date().toISOString().split('T')[0]
          )
          document.body.appendChild(fileLink)
          fileLink.click()
        })
    },
    rawdata_excel_download () {
      this.$store
        .dispatch('gdqreport_rawdata_excel_get', {
          survey_id: this.survey_id,
          full: 1
        })
        .then((resp) => {
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            `GDQ_RawData_${this.survey_id}_${
              new Date().toISOString().split('T')[0]
            }.xlsx`
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          document.body.removeChild(fileLink)
          window.URL.revokeObjectURL(fileURL)
        })
    },
    rawdata_excel_download_limited () {
      this.$store
        .dispatch('gdqreport_rawdata_excel_get', {
          survey_id: this.survey_id,
          full: 0
        })
        .then((resp) => {
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            `GDQ_RawData_Limited_s${this.survey_id}_${
              new Date().toISOString().split('T')[0]
            }.xlsx`
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          document.body.removeChild(fileLink)
          window.URL.revokeObjectURL(fileURL)
        })
    },

    receipt_download () {
      this.$store
        .dispatch('gdqreport_receipt_create', { survey_id: this.survey_id })
        .then((resp) => {
          var byteCharacters = atob(resp.data)
          var byteNumbers = new Array(byteCharacters.length)
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          var byteArray = new Uint8Array(byteNumbers)
          var blob = new Blob([byteArray], { type: 'application/pdf' })
          var fileURL = window.URL.createObjectURL(blob)
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            'GDQ_Receipt_' +
              this.survey_id +
              '_' +
              new Date().toISOString().split('T')[0]
          )
          document.body.appendChild(fileLink)
          fileLink.click()
        })
    },
    invoice_updateinfo () {
      var invoice = {
        invoice_reference: this.invoice_reference,
        invoice_name: this.invoice_name,
        invoice_company: this.invoice_company,
        invoice_address_1: this.invoice_address_1,
        invoice_address_2: this.invoice_address_2,
        invoice_zip_code: this.invoice_zip_code,
        invoice_city: this.invoice_city,
        invoice_company_regno: this.invoice_company_regno,
        invoice_email: this.invoice_email,
        e_invoice: this.e_invoice
      }
      this.$store
        .dispatch('groupsurveyinvoice_save', {
          invoice_id: this.invoice_id,
          invoice: invoice
        })
        .then((resp) => {
          this.checkform()
        })
    },
    invoice_save () {
      var invoice = {
        invoice_reference: this.invoice_reference,
        invoice_name: this.invoice_name,
        invoice_company: this.invoice_company,
        invoice_address_1: this.invoice_address_1,
        invoice_address_2: this.invoice_address_2,
        invoice_zip_code: this.invoice_zip_code,
        invoice_city: this.invoice_city,
        invoice_company_regno: this.invoice_company_regno,
        e_invoice: this.e_invoice,
        invoice_status: 2,
        invoice_payment_method_id: this.payment,
        coupon_id: this.coupon_id,
        invoice_email: this.invoice_email
      }
      this.$store
        .dispatch('groupsurveyinvoice_save', {
          invoice_id: this.invoice_id,
          invoice: invoice
        })
        .then((resp) => {
          this.report_paid = 1
          this.$nextTick(() => {
            this.$store.dispatch('groupsurveyinvoice_notifyadmin', {
              invoice_id: this.invoice_id
            })
            var action = 'gdqreport_create'
            if (this.survey.survey_type_id == 2) {
              action = 'gdqshortreport_create'
            }
            if (this.survey.survey_type_id == 3) {
              action = 'oscreport_create'
            }
            if (this.spotify === '1') {
              action = 'gdqshortreport_spotify_create'
            }
            this.$store
              .dispatch(action, { survey_id: this.survey_id })
              .then((resp) => {
                this.report_id = resp.data.id
                this.report_loaded = 1
              })
          })
        })
    },
    // Save invoice contact info before redirecting to Nets card payment
    prepareNetsPayment () {
      if (!this.invoice_id || this.invoice_id <= 0) {
        return Promise.reject(new Error('Invoice not created'))
      }
      var invoice = {
        invoice_reference: this.invoice_reference,
        invoice_name: this.invoice_name,
        invoice_company: this.invoice_company,
        invoice_address_1: this.invoice_address_1,
        invoice_address_2: this.invoice_address_2,
        invoice_zip_code: this.invoice_zip_code,
        invoice_city: this.invoice_city,
        invoice_company_regno: this.invoice_company_regno,
        invoice_email: this.invoice_email,
        e_invoice: this.e_invoice,
        invoice_payment_method_id: 4,
        invoice_status: this.invoice_status
      }
      return this.$store.dispatch('groupsurveyinvoice_save', {
        invoice_id: this.invoice_id,
        invoice: invoice
      })
    },
    startNetsPayment () {
      this.prepareNetsPayment()
        .then(() => {
          if (this.$refs.netsPayment && this.$refs.netsPayment.nets_payment) {
            this.$refs.netsPayment.nets_payment()
          } else {
            alert('Could not start payment')
          }
        })
        .catch((err) => {
          alert(
            'Could not start payment: ' +
              (err && err.message ? err.message : err)
          )
        })
    },
    checkform () {
      this.formok = true
      if (this.invoice_name == '') {
        this.formok = false
      }
      if (this.invoice_company == '') {
        this.formok = false
      }
      if (this.invoice_company_regno == '') {
        this.formok = false
      }
      if (this.invoice_accept == false) {
        this.formok = false
      }
      if (this.invoice_reference == '') {
        this.formok = false
      }
    },
    checkcoupon () {
      this.couponok = null
      if (this.coupon_code == '') {
        this.couponok = false
        return false
      }
      var filter = {
        consultant_id: {
          operator: '=',
          value: this.$store.state.user_id
        },
        coupon_code: {
          operator: '=',
          value: this.coupon_code
        },
        coupon_invoice_id: {
          operator: '=',
          value: 0
        }
      }
      this.$store
        .dispatch('records_readall', {
          table_name: 'g_consultant_coupons',
          filter: filter
        })
        .then((resp) => {
          if (resp.data.result.length != 1) {
            this.couponok = false
          } else {
            this.coupon_id = resp.data.result[0].id
            var invoice = {
              invoice_reference: this.invoice_reference,
              invoice_name: this.invoice_name,
              invoice_company: this.invoice_company,
              invoice_address_1: this.invoice_address_1,
              invoice_address_2: this.invoice_address_2,
              invoice_zip_code: this.invoice_zip_code,
              invoice_city: this.invoice_city,
              invoice_company_regno: this.invoice_company_regno,
              invoice_status: 2,
              invoice_payment_method_id: this.payment,
              coupon_id: this.coupon_id,
              invoice_email: this.invoice_email
            }
            this.$store
              .dispatch('groupsurveyinvoice_save', {
                invoice_id: this.invoice_id,
                invoice: invoice
              })
              .then((resp) => {
                this.$store
                  .dispatch('record_put', {
                    table_name: 'g_consultant_coupons',
                    id: this.coupon_id,
                    record: { coupon_invoice_id: this.invoice_id }
                  })
                  .then(() => {
                    this.report_paid = 1
                    this.$nextTick(() => {
                      var action = 'gdqreport_create'
                      if (this.survey.survey_type_id == 2) {
                        action = 'gdqshortreport_create'
                      }
                      if (this.survey.survey_type_id == 3) {
                        action = 'oscreport_create'
                      }
                      if (this.spotify === '1') {
                        action = 'gdqshortreport_spotify_create'
                      }
                      this.$store
                        .dispatch(action, { survey_id: this.survey_id })
                        .then((resp) => {
                          this.report_id = resp.data.id
                          this.report_loaded = 1
                        })
                    })
                  })
              })
          }
        })
      return false
    },
    groupsurvey_get () {
      this.survey = this.$store.state.currentsurvey
      this.survey_stage_id = this.survey.survey_stage_id
      this.survey_id = this.survey.id
      this.spotify = this.survey.spotify
      this.invoice_reference = this.survey.survey_invoice_reference
      this.$store
        .dispatch('record_read', {
          table_name: 'g_surveytypes',
          id: this.survey.survey_type_id
        })
        .then((resp) => {
          this.surveytype_name = resp.data.surveytype_name
        })
    },
    // ----------------------------------------------------------------
    // Get/create invoice for any unprocessed surveymembers
    // invoice_status:
    // 0 = There are invoices to be paid/handle
    // 1 = Not used
    // 2 = All invoices created and payment selected
    // report_paid:
    // 0 = We have not done the payment processing to end
    // 1 = The payment processing is finished (inv or return from DIBS)
    // report_loaded:
    // 0 = The report has not been loaded
    // 1 = The report has been loaded
    // ----------------------------------------------------------------
    invoice_get () {
      this.$store
        .dispatch('groupsurveyinvoice_fetch', { survey_id: this.survey.id })
        .then((resp) => {
          this.invoice_id = resp.data.invoice_id
          this.invoice = resp.data.invoice || {}
          this.order_id = 1000000 + parseInt(this.invoice_id)
          // We found or just generated an unpaid invoice
          if (this.invoice_id > 0) {
            this.invoice_status = resp.data.invoice.invoice_status
            this.invoicedetails = resp.data.invoice.invoicedetails
            this.invoicehead.push({
              label: 'Invoice Number',
              value: resp.data.invoice.invoice_number
            })
            this.invoicehead.push({
              label: 'Seller',
              value: 'GDQ Associates AB'
            })
            this.invoicehead.push({
              label: 'Organisation number',
              value: '556995-0016'
            })
            this.invoicehead.push({
              label: 'Invoice Date',
              value: resp.data.invoice.invoice_date
            })
            this.invoicehead.push({
              label: 'Invoice Reference',
              value: resp.data.invoice.invoice_reference
            })
            this.invoice['dibs_amount'] =
              this.invoice.invoice_amount_inc_vat.replace(',', '')
          } else {
            this.invoice_status = 2
          }
          // Prefill invoice fields from current or previous invoice, but allow user edits
          const previousInvoice = resp.data.previous_invoice || {}
          const preferValue = (key, fallback) => {
            if (!this[key] || this[key] === '') {
              if (this.invoice && this.invoice[key]) {
                this[key] = this.invoice[key]
              } else if (previousInvoice[key]) {
                this[key] = previousInvoice[key]
              } else if (fallback !== undefined) {
                this[key] = fallback
              }
            }
          }
          preferValue('invoice_reference')
          preferValue('invoice_name')
          preferValue('invoice_company')
          preferValue('invoice_address_1')
          preferValue('invoice_address_2')
          preferValue('invoice_zip_code')
          preferValue('invoice_city')
          preferValue('invoice_company_regno')
          preferValue('invoice_email')
          preferValue('e_invoice', 1)
          // -----------------------------------------------------------------
          // The invoice id returned is the newly created invoice id (if any)
          // If invoice_id = 0, we have already created all invoices required
          // and thus can display the report, otherwise, we do nothing
          // This gives us a challenge if the consultant backs out and then
          // comes back again. Hmmmmmmm
          // -----------------------------------------------------------------
          if (this.invoice_status == 2) {
            var action = 'gdqreport_create'
            if (this.survey.survey_type_id == 2) {
              action = 'gdqshortreport_create'
            }
            if (this.survey.survey_type_id == 3) {
              action = 'oscreport_create'
            }
            if (this.spotify === '1') {
              action = 'gdqshortreport_spotify_create'
            }
            this.$store
              .dispatch(action, { survey_id: this.survey_id })
              .then((resp) => {
                this.report_id = resp.data.id
                this.report_paid = 1
                this.report_loaded = 1
              })
            // })
          }
        })
    }
  }
}
</script>
<style scoped></style>
<style>
.hidden_header {
  display: none;
}
.btn-coupon {
  border-radius: 0px !important;
}
</style>
